import { Project, Category, Folder } from "./types"

export const FOLDER_COLORS = [
  "oklch(0.65 0.18 250)",   // azul
  "oklch(0.65 0.18 150)",   // verde
  "oklch(0.70 0.18 50)",    // laranja
  "oklch(0.60 0.20 350)",   // rosa
  "oklch(0.65 0.15 80)",    // amarelo
]

export const initialProjects: Project[] = [

]

export const initialFolders: Folder[] = [

]

export const initialCategories: Category[] = []


